import { Chain } from '@1delta/chain-registry'
import { fetchPendleYields } from '../../../prices/pendle'
import { getListsMulti } from '../../helpers'
import { YieldFetcher } from '../../types'

export const pendleFetcher: YieldFetcher = {
  label: 'PENDLE',
  fetch: async () => {
    const lists = await getListsMulti([
      Chain.PLASMA_MAINNET,
      Chain.ETHEREUM_MAINNET,
      Chain.BERACHAIN,
      Chain.MANTLE,
      Chain.BASE,
      Chain.OP_MAINNET,
      Chain.ARBITRUM_ONE,
      Chain.SONIC_MAINNET,
      Chain.HYPEREVM,
      Chain.BNB_SMART_CHAIN_MAINNET,
    ])
    return fetchPendleYields(lists)
  },
}
